import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import CreateCaseModel from '../../models/CreateCaseModel';
import EditFields from '../common/EditFields';

const useStyles = makeStyles((theme) => {
  return {
    fieldContainer: {
      marginTop: '16px 0 10px',
    },
    labels: {
      marginBottom: '1rem',
    },
  };
});

export default ({ onChangeFormStatus, status }) => {
  const [formStatus, setFormStatus] = useState(status);
  const classes = useStyles();
  const questionRef = useRef();
  const questionField = useMemo(
    () => [
      {
        className: `custom-height custom-contained-helper-text ${classes.fieldContainer}`,
        multiline: true,
        name: 'question',
        onChange: (value, isValid) => {
          onChangeFormStatus(value, 'question', isValid);
        },
        placeholder: 'Type any questions here.',
        required: true,
        rows: 4,
        type: 'text',
        variant: 'outlined',
      },
    ],
    []
  );

  useEffect(() => {
    setFormStatus(status);
  }, [status]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <EditFields
          useAutoFocus={false}
          validate={CreateCaseModel.validateRequestReport}
          data={formStatus.formStatus}
          labelPosition="top"
          ref={questionRef}
          useLabel={false}
          fields={questionField}
        />
        <Typography variant="body1" className="body-copy" align="left">
          Please remember that your video report is meant to help explain your findings only,&nbsp;
          <span style={{ color: '#172B4D' }}>your imaging education specialist will not provide any treatment advice.</span>
        </Typography>
      </Grid>
    </Grid>
  );
};
